<template>
    <div>
        <div class="banner"></div>
        <div class="w1200" style="margin-top:0">
            <div class="head clearfix">
                <HT text="lxwm" class="fl" style="margin-top:20px"></HT>
                <div class="fr bread clearfix">
                    <div class="fl" style="margin-right:15px;color: #064186">当前位置:</div>
                    <div class="fl">
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '/contactus' }">联系我们</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="mapWrap pr">
                    <div id="container">
                        <div id="l-map">
                        </div>
                    </div>
                </div>
                <div class="messageWrap pr">
                    <h2>在线留言</h2>
                    <div class="from">
                        <input type="text" placeholder="您的姓名" v-model="name" /><input type="text" placeholder="您的联系方式" style="margin-right:0" v-model="phone" />
                        <textarea placeholder="请填写内容" v-model="message"></textarea>
                    </div>
                    <div class="button" @click="postMessage()">提交留言</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { MP } from '@/assets/utils/map.js'
import HT from '@/components/h2.vue'
export default {
    data() {
        return {
            ak: '4wBiGfagqh5KcQLp8GiVcGsvevAGKWGT',
            from: null,
            to: null,
            name: "",
            phone: "",
            message: ""
        }
    },
    components: {
        HT
    },
    mounted(){
        
                this.getMap()
    },
    methods: {//定义方法
        getMap() {
            var map = new BMap.Map('l-map');
            var poi = new BMap.Point(121.141026,27.828893);
            var poi1 = new BMap.Point(120.6596242865,28.0049708793);
            map.centerAndZoom(poi, 11);

            var content = '<div style="margin:0;line-height:20px;padding:2px;">' +
                            '<img src="../img/baidu.jpg" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin-left:3px;"/>' +
                            '地址：温州市鹿城区世贸中心大厦3806室<br/>电话：(0577)-88125111<br/>' +
                        '</div>';
            var content1 = '<div style="margin:0;line-height:20px;padding:2px;">' +
                            '<img src="../img/baidu.jpg" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin-left:3px;"/>' +
                            '地址：温州市洞头区北岙街道溢香路86号B幢<br/>电话：(0577)-88125111<br/>' +
                        '</div>';
    //创建检索信息窗口对象
            var searchInfoWindow = null;
            var searchInfoWindow = new BMapLib.SearchInfoWindow(map, content1, {
                    title  : "固德医药洞头总公司",      //标题
                    width  : 290,             //宽度
                    height : 85,              //高度
                    panel  : "panel",         //检索结果面板
                    enableAutoPan : true,     //自动平移
                    searchTypes   :[
                        BMAPLIB_TAB_SEARCH,   //周边检索
                        BMAPLIB_TAB_TO_HERE,  //到这里去
                    ]
                });
            var searchInfoWindow1 = null;
            var searchInfoWindow1 = new BMapLib.SearchInfoWindow(map, content, {
                title  : "固德医药鹿城分公司",      //标题
                width  : 290,             //宽度
                height : 85,              //高度
                panel  : "panel",         //检索结果面板
                enableAutoPan : true,     //自动平移
                searchTypes   :[
                    BMAPLIB_TAB_SEARCH,   //周边检索
                    BMAPLIB_TAB_TO_HERE,  //到这里去
                ]
            });
            var label = new window.BMap.Label("固德医药洞头总公司", {
                offset : new window.BMap.Size(20, -10)
            });
            var label1 = new window.BMap.Label("固德医药鹿城分公司", {
                offset : new window.BMap.Size(20, -10)
            });
            var marker = new BMap.Marker(poi);
            marker.setLabel(label)
            var marker1 = new BMap.Marker(poi1)
            marker1.setLabel(label1)
             //创建marker对象
            marker.setAnimation(BMAP_ANIMATION_BOUNCE); 
            marker1.setAnimation(BMAP_ANIMATION_BOUNCE); 
            marker.addEventListener("click", function(){
                searchInfoWindow.open(marker);
            })
            marker1.addEventListener("click", function(){
                searchInfoWindow1.open(marker1);
            })
            map.addOverlay(marker); //在地图中添加marker
            map.addOverlay(marker1)
            searchInfoWindow.open(marker);
            map.addControl(new BMap.NavigationControl(
                {
                    type : BMAP_NAVIGATION_CONTROL_ZOOM, //缩放控件类型 仅包含缩放按钮
                    anchor : BMAP_ANCHOR_BOTTOM_RIGHT, //右下角
                    offset : new BMap.Size(1,1) //进一步控制缩放按钮的水平竖直偏移量
                }
            ));
        },
        postMessage() {
            alert(this.$data.name + this.$data.phone + this.$data.message)
        }
    }
}
</script>
<style scoped>
    .banner{
        width: 100%;
        height: 400px;
        background: url('../../assets/images/contactus.jpg') center center no-repeat;
        background-size: auto 100%;
    }
    .w1200{
        margin: 0 auto;
        margin-top: 60px;
    }
    .bread{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 50px;
    }
    .el-breadcrumb{
        line-height: 20px;
    }
    .head{
        padding-bottom: 23px;
        border-bottom: 2px solid #134b8c;
    }
    .mapWrap,.messageWrap{
        width: 100%;
        height: 510px;
        border: 2px solid #e6e6e6;
        border-radius: 1px;
        margin-top: 60px;
    }
    .messageWrap{
        margin-bottom: 115px;
        padding: 53px 60px;
        width: auto;
    }
    .messageWrap input{
        width: 528px;
        height: 50px;
        background: #f5f5f5;
        border: none;
        margin-right: 20px;
        text-indent: 2em;
        font-size: 16px;
    }
    .messageWrap textarea{
        width: 1012px;
        height: 215px;
        background: #f5f5f5;
        border: none;
        padding: 2em;
        margin-top: 20px;
        font-size: 16px;
        resize: none;
    }
    #l-map{
        width: 1200px;
        height: 514px;
    }
    h2{
        font-size: 35px;
        font-weight: 700;
        letter-spacing: 3px;
    }
    .button{
        width: 155px;
        height: 61px;
        line-height: 61px;
        background: #033f85;
        color: #fff;
        text-align: center;
        margin-top: 20px;
    }
</style>

<style>
    .anchorBL{
        display: none;
    }
</style>

